import React from 'react';

import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import i18n from 'i18n';
import {
  DashboardEnvironmentsCostGraphFields,
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import AutoCard from 'components/AutoCard';
import { getDashboardEnvironmentCostGraphRequest } from 'modules/environments/actions';
import { useParams } from 'react-router';
import { formatCurrency } from 'utils/helpers';
import { modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import EnvironmentCostGraph from './EnvironmentCostGraph';
import styles, { overrideCardGraph, overrideModalGraph } from './styles';
import EnvironmentCostGraphModal from './EnvironmentCostGraphModal';

interface EnvironmentCostGraphCardProps {
  dashboardEnvironmentCostGraph: DashboardEnvironmentsCostGraphFields;
  dateFilter?: DateFilterFields;
  intervalTime: PeriodCountAccess;
  getDashboardEnvironmentCostGraphRequest: ({ id, query }) => void;
  modalOpen: (props: ModalFields) => void;
}

const EnvironmentCostGraphCard = ({
  dashboardEnvironmentCostGraph,
  dateFilter,
  intervalTime,
  getDashboardEnvironmentCostGraphRequest,
  modalOpen,
}: EnvironmentCostGraphCardProps) => {
  const classes = makeStyles(styles())();
  const { id } = useParams<{
    id: string;
  }>();
  const { breakpoints } = useTheme();

  const getDashboardEnvironmentCostGraph = React.useCallback(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period: intervalTime };

    getDashboardEnvironmentCostGraphRequest({
      id,
      query,
    });
  }, [getDashboardEnvironmentCostGraphRequest, intervalTime, id, dateFilter]);

  React.useEffect(() => {
    getDashboardEnvironmentCostGraph();
  }, [getDashboardEnvironmentCostGraph]);

  const handleOpenGraphModal = () => {
    modalOpen({
      overrideClasses: overrideModalGraph,
      maxWidth: 'xl',
      title: i18n.t('PERFORMANCE_PAGE.ENVIRONMENT_COSTS_DETAILS_KEY'),
      content: <EnvironmentCostGraphModal />,
      onClose: () => getDashboardEnvironmentCostGraph(),
      genericFooter: {},
    });
  };

  return (
    <Grid item className={classes.containerCard}>
      <Grid item>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography className={classes.graphTitle}>
              {i18n.t('ENVIRONMENT_DASHBOARD.ENVIRONMENT_COST_TITLE_KEY')}
              {': '}
              {formatCurrency(dashboardEnvironmentCostGraph?.total)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
        <Grid
          container
          className={classes.containerGraph}
          onClick={handleOpenGraphModal}
        >
          <EnvironmentCostGraph />
        </Grid>
      </AutoCard>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { dashboardEnvironmentCostGraph, periodFilter },
}: ApplicationState) => ({
  intervalTime: periodFilter,
  dashboardEnvironmentCostGraph,
});
export default connect(mapStateToProps, {
  getDashboardEnvironmentCostGraphRequest,
  modalOpen,
})(EnvironmentCostGraphCard);
